import React from 'react';
import config from '../../config';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Modal, Row, Col} from 'react-bootstrap';
import AddRequirementForm from '../runs/AddRequirementForm';
import * as commonActions from '../../actions/commonActions';
import label from '../../utils/lngEn';

class AddGroupRequirementModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      name: {
        value: '', style: null, message: ''
      },
      requirement: {
        title: '',
        gsId: '',
        initialValues: {
          is_time_conflict: false
        }
      },
      errorName: '',
      errorKind: '',
      errorLimit: '',
      errorCourses: ''
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({requirement: nextProps.initial});
  }

  handleSubmit (values) {
    // let error = false;

    let promise = new Promise((resolve) => {
      if(!values.name) {
        this.setState({errorName :'Required'});
      } else {
        this.setState({errorName: null});
      }
      if(!values.kind) {
        this.setState({errorKind :'Required'});
      } else {
        this.setState({errorKind: null});
      }
      if(!values.limit) {
        this.setState({errorLimit: 'Required'});
      } else {
        this.setState({errorLimit: null});
      }
      if(!values.courses) {
        this.setState({errorCourses: 'Required'});
      } else {
        this.setState({errorCourses: null});
      }
      return resolve();
    });
    promise.then(() => {

      return new Promise((resolve,reject) => {
        if(this.state.errorName !== null || this.state.errorKind  !== null || this.state.errorLimit !== null || this.state.errorCourses !== null) {
          return reject();
        } else {
          return resolve();
        }
      });
    }).then(()=> {
      let obj = {};
      if(typeof(values.courses[0]) == 'object') {
        obj.courses = values.courses.map(c => {
          return c.id;
        });
      } else {
        obj.courses = values.courses;
      }
      if(typeof(values.kind) == 'object') {
        obj.kind = values.kind.value;
      } else {
        obj.kind = values.kind;
      }
      if(typeof(values.limit) == 'object') {
        if(values.limit.value == 'all') {
          obj.limit = obj.courses.length;
        } else {
          obj.limit = +values.limit.value;
        }
      } else {
        if(values.limit == 'all') {
          obj.limit = obj.courses.length;
        } else {
          obj.limit = +values.limit;
        }
      }
      obj.name = values.name;

      if(values.id) {
        // Edit Restriction
        obj.id = values.id;
        this.props.commonActions.putGSRestriction(this.state.requirement.gsId, obj, this.state.requirement.type , config.requirements).then(() => {
          this.props.closeModal();
          this.props.commonActions.getAllGSRestrictions(this.state.requirement.gsId, this.state.requirement.type, config.requirements);
        }).catch(err => {
          console.log('error', err.message);
        });
      } else {
        // Add Restriction
        this.props.commonActions.addNewGSRestriction(this.state.requirement.gsId, obj,this.state.requirement.type, config.requirements).then(() => {
          this.props.closeModal();
          this.props.commonActions.getAllGSRestrictions(this.state.requirement.gsId, this.state.requirement.type, config.requirements);
        }).catch(err => {
          console.log('error', err.message);
        });
      }
    })
      .catch(() => {
        console.log('error on the form');
      });
  }

  render(){
    return (
      <Modal show={this.props.showModal} onHide={this.props.closeModal} backdrop="static" className="addConflictModal">
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                {this.state.requirement.title || label.createRequirement}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{this.state.requirement.initialValues.id ? '' : label.createRequirementModalBody}</p>
          <AddRequirementForm
            onSubmit={this.handleSubmit}
            onCancel={this.props.onCancel}
            initialValues={this.state.requirement.initialValues}
            coursesArray={this.props.courses}
            errorName = {this.state.errorName}
            errorKind = {this.state.errorKind}
            errorLimit = {this.state.errorLimit}
            errorCourses = {this.state.errorCourses}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    courses: state.courses
  };
}

function mapDispatchToProps(dispatch) {
  return {
    commonActions: bindActionCreators(commonActions, dispatch)
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(AddGroupRequirementModal);



// WEBPACK FOOTER //
// ./src/components/common/AddGSRequirementModal.js